import { render } from "./PortadaNosotros.vue?vue&type=template&id=71df06ec&scoped=true"
import script from "./PortadaNosotros.vue?vue&type=script&lang=js"
export * from "./PortadaNosotros.vue?vue&type=script&lang=js"

import "./PortadaNosotros.vue?vue&type=style&index=0&id=71df06ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71df06ec"]])

export default __exports__